import React from "react";

function DropBtn() {
  return (
    <>
      <div className="p-3 border rounded dark:bg-[#1C1C25] border-[#d9dce1] dark:border-[#3a3d4b]">
        <svg
          width="14"
          height="3"
          viewBox="0 0 14 3"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.48535 3C2.08753 3 1.706 2.84196 1.42469 2.56066C1.14339 2.27936 0.985352 1.89782 0.985352 1.5C0.985352 1.10218 1.14339 0.720644 1.42469 0.43934C1.706 0.158035 2.08753 0 2.48535 0C2.88318 0 3.26471 0.158035 3.54601 0.43934C3.82732 0.720644 3.98535 1.10218 3.98535 1.5C3.98535 1.89782 3.82732 2.27936 3.54601 2.56066C3.26471 2.84196 2.88318 3 2.48535 3ZM7.48535 3C7.08753 3 6.706 2.84196 6.42469 2.56066C6.14339 2.27936 5.98535 1.89782 5.98535 1.5C5.98535 1.10218 6.14339 0.720644 6.42469 0.43934C6.706 0.158035 7.08753 0 7.48535 0C7.88318 0 8.26471 0.158035 8.54601 0.43934C8.82732 0.720644 8.98535 1.10218 8.98535 1.5C8.98535 1.89782 8.82732 2.27936 8.54601 2.56066C8.26471 2.84196 7.88318 3 7.48535 3ZM12.4854 3C12.0875 3 11.706 2.84196 11.4247 2.56066C11.1434 2.27936 10.9854 1.89782 10.9854 1.5C10.9854 1.10218 11.1434 0.720644 11.4247 0.43934C11.706 0.158035 12.0875 0 12.4854 0C12.8832 0 13.2647 0.158035 13.546 0.43934C13.8273 0.720644 13.9854 1.10218 13.9854 1.5C13.9854 1.89782 13.8273 2.27936 13.546 2.56066C13.2647 2.84196 12.8832 3 12.4854 3Z"
            fill="#7F8A9B"
            fillOpacity="0.4"
          />
        </svg>
      </div>
    </>
  );
}

export default DropBtn;
